// Recovered compiled webpack factory 1666. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }), r(28110));
  let n = r(53663),
    a = r(83843);
  ((0, n.appBootstrap)(() => {
    let { hydrate: e } = r(49781);
    (r(17297), r(9766), e(a));
  }),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
